import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.lg,
		maxWidth: 720,
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		gap: 8,
	},
	runNowContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	requiredIndicator: {
		color: THEME.colors.danger.main,
	},
	helpText: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	statusLine: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	scheduleFields: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
	},
	scheduleDaysRow: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.md,
		alignItems: 'center',
		fontSize: THEME.typography.fontSizes.sm,
	},
	scheduleDay: {
		cursor: 'pointer',
		gap: THEME.spacing.xs,
	},
	scheduleTimeRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	timeComboboxInput: {
		maxWidth: 140,
	},
	footer: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.sm,
	},
	textArea: {
		minHeight: 128,
	},
});
